module.exports = __webpack_public_path__ + "img/Progress-Report-Process-6-mobile.372b66d6.png";